export const globalNavModule = {
  name: 'Global Navigation',
};
